export default __webpack_public_path__ + "static/media/HistoryEmpty.199e15fc.svg";